import { Copy } from 'lucide-react';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@/components/shadcn/ui/input-group';
import { toast } from '@/stores/pure/ToastStore';
import { clipboardCopy } from '@/utils/util';

import { useSharedLinkForm } from './shared-link-form-context';

export function ShareLinkInput() {
  const form = useSharedLinkForm();
  const handleCopy = (link: string) => {
    clipboardCopy(link);
    toast('Link copied to clipboard', 'success');
  };

  return (
    <form.AppField
      name="isPublic"
      children={() => (
        <form.AppField
          name="sharedLink"
          children={(field: any) => (
            <InputGroup>
              <InputGroupInput value={field.state.value} readOnly />
              <InputGroupAddon className="rounded-md" align="inline-end">
                <InputGroupButton
                  className="rounded-md"
                  variant="default"
                  onClick={() => handleCopy(field.state.value)}
                >
                  <Copy />
                  Copy link
                </InputGroupButton>
              </InputGroupAddon>
            </InputGroup>
          )}
        />
      )}
    />
  );
}
